// export const BASE_URL = "https://edonation-dev-api.givepls.com/api/eDonation"; //DEV Server
// export const BASE_URL = "https://edonation-uat-api.givepls.com/api/eDonation"; // UAT Server commented not AUTH
// export const BASE_URL = "https://x59secw1jf.execute-api.ap-southeast-1.amazonaws.com/Stage/api/eDonation"; // DEV with AUTH
//export const BASE_URL = "https://kv0hdmvonc.execute-api.ap-southeast-1.amazonaws.com/Stage/api/eDonation"; // UAT new with AUTH
// export const BASE_URL =  "https://edonation-uat-api.givepls.com/api/eDonation";
// export const SINGPASS_URL = "https://app.givepls.com/"; // UAT singpass url change as per suyoug suggetions
export const SINGPASS_URL = "https://app.givepls.com/"; // NGS singpass url for QR code generation 
export const LOGIN_SINGPASS_URL  = 'https://enrol.givepls.com/'
//DEV - https://staging.givepls.com //UAT, PROD - https://app.givepls.com
export const NGS_SINGPASS_ENV = 'PROD'; // DEV, UAT, PROD
export const BASE_URL =  "https://edonation-prod-upgradedapi.givepls.com/v8/api/eDonation";
export const BASE_S3_URL = "https://d2gmjq25p3xvt5.cloudfront.net/cpas/images/"; // local: images/  |  https://s3.ap-south-1.amazonaws.com/s3web-asset.givepls.com/cpas/images/

//--------------------AUTH0 DETAILS ----------------------
export const REACT_APP_AUTH0_DOMAIN = "login.nationalgallery.sg"; 
export const REACT_APP_AUTH0_CLIENT_ID = "EmJw2fwhvAwsOhQ9JACaMLPmQxQMcoI0";
export const CONNECTION_TYPE = "Username-Password-Authentication";

// -------------------- NGS DETAILS ----------------------- 
export const ENROLL_MANULLY_ID = 1;
export const ENROLL_CORPORATE_ID = 2;
export const CPAS_CHARITY_ID = 98;
export const DONATION_AMOUNT = 1000000000000000;
export const PAYMENT_METHOD = 'WorldPay';
export const CLIENT_PARAM = 'CPAS';
export const SINGPASS_SEPERATOR = '_';
export const SINGPASS_PLATFORM =  'web';
export const SINGPASS_APPS = {
      MYINFO: 'myinfo',
      SGVERIFY: 'sgverify'
   }

export const DEFAULT_API_ERROR = `Our server is down, we'll back to normal soon`

export const CARD_TYPES = {
    VISA: 'VISA',
    MASTERCARD: 'Mastercard',
    AMEX: 'Amex',
    AMERICANEXPRESS: 'AMERICANEXPRESS',
    JCB: 'JCB',
    UNIONPAY: 'UNIONPAY',
    DINNERSCLUB: 'DINNERSCLUB',    
    ECMC: 'ECMC'
}

export const PAYMENT_PARTNER = {
    WORLDPAY : 'WorldPay',
}

export const RESPONSE_CODES = {
    SUCCESS : 1,
    FAILURE : 0
}

export const REGEX = {
    TITLECASE : /\b(\w)/g,
    NRIC: /^[STFGM]\d{7}[A-Z]$/,
    UEN: /^[A-Za-z0-9]*$/,
    UEN1: /((S|T|[0-9])([a-zA-Z0-9]{8,9})|([0-3])(\d{8})([A-Z]))/g,
    COMPANY_NAME: /^[a-zA-Z0-9\-&.\s]*$/,
    CONTACT_PERSON: /^[a-zA-Z\s]*$/,
    EMAIL_ADDRESS: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
    PASSWORD:/^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{7,}$/,
};

export const MODAL_MESSAGE = {
    ERROR : 'Oops! Something went wrong'
}

export const DEFAULT_ORDER = 1;
export const DEFAULT_CARD_NAME = 'Card Holder Name';
export const WORLD_PAY_BASE_URL = "https://l81c6bg7gf.execute-api.ap-southeast-1.amazonaws.com/Stage/api/eDonation";
export const GOOGLE_POSTAL_CODE_BASE_URL = 'https://maps.googleapis.com/maps';

//----------------- HOMEPAGE BLOCK IDS ------------------- 
export const NEWS_LETTER_BLOCK_ID = 13;
export const GALLARY_EXPLORE_BLOCK_ID = 14;
export const CONTACT_US_BLOCK_ID = 15;
export const SOCIAL_MEDIA_BLOCK_ID = 16;
export const DONATION_BLOCK_ID = 5;
export const ADOPT_ART_WORK_BLOCK_ID = 6;
export const CORE_PRIVILEDGE_BLOCK_ID = 9;
export const PATRON_HEADING_BLOCK_ID = 8;
export const PATRON_PROGRAM_BLOCK_ID = 10;
export const DONOR_WALL_BLOCK_ID = 12;
export const ACHIEVEMENTS_BLOCK_ID = 7;
export const DONATION_WIDGET__BLOCK_ID = 4;

//--------------------------------------------------
export const DONOR_WALL_DONOTE_NOW_SETTING_ID = 16;
export const DONOR_WALL_SEE_WALL_SETTING_ID = 15;
export const DATE_FORMAT_DAYS = 'DD MMM';
export const DATE_FORMAT_YEARS = 'DD MMM YYYY'

//------------------------------------------------------
export const DONATION_MIN_AMOUNT = 5;
export const DONATION_MAX_AMOUNT = 999999;

export const CONTACT_US = "";
export const SUPPORT = "";
// export const SITE_MAP = "";
// export const TERMS_OF_USE = "";
export const PRIVACY_POLICY = "https://cpas.org.sg/about-cpas/data-protection-policy/";
export const TERMS_CONDITION = "https://cpas.org.sg/about-cpas/data-protection-policy/";

//------------------------------------------------------

export const PATRON_MIN_AMOUNT = 2000;
export const PATRON_MAX_AMOUNT = 999999;

export const ADOPT_MIN_AMOUNT = 50;
export const ADOPT_MAX_AMOUNT = 200000;
export const DATE_FORMAT = 'D MMM YYYY'; // 04 Jan 2019
export const HOUR_MINS = 'h:mm A';  // Hour and minute with AM/PM

export const PAYMENT_TYPES = {
    CARD_PAYMENT: 1,
    GOOGLE_PAY: 2,
    APPLE_PAY: 3,
    PAY_NOW: 8
}

export const PAYMENT_ORDER = 1;
export const PAYMENT_METHODS = {
    GRAB_PAY: 'grabpay',
    APPLE_PAY: 'applepay',
    ALI_PAY: 'alipay',
    GOOGLE_PAY: 'googlepay',
    PAY_NOW: 'paynow',
    STATIC_PAYNOW: 'staticpaynow',
    STATIC_PAYNOW_QR_CODE: 'staticpaynowqrcode',
    BANK_TRANSFER: 'banktransfer',
    CASH: 'cash',
    CHEQUE: 'cheque',
}

export const PaymentStatus = { SUCCESS: 0, FAILURE: 1, CANCEL: 2 };
export const CRYPTO_ACCESS_KEY = "ptjXV9hR%EC&a!QK";
export const AWS_SECRET_ACCESS_KEY = "U2FsdGVkX19SSs7Wngm0SOJb1tOINsx/drLuRiOcWlRAR/cfD8M5qciOkZu4wIn+1Zx8YbSqN1CAkzD+LSvBdw==";
export const AWS_SECRET_KEY_ID = "U2FsdGVkX18sOS02jd4PiWKlw1k9k90Z5dMo05ODSHzoEhOEKk4Rsl21rODKTFrR";
export const AWS_REGION = "ap-southeast-1"
export const GOOGLE_API_KEY_AUTOCOMPLETE ='AIzaSyBU8HZ7l83Zbc8IxIaEhgO4MyfkzcWU1d0';

// Auth Pool Creds
export const USER_NAME_AWS_COGNITO = 'prodcpas';
export const PASSWORD_AWS_COGNITO = 'U2FsdGVkX19Qmvn1v0pDNXmBTphY5tlfizV0SHxagZiM3YvcUM4jdxkMjWkeQ3HI';
// export const EMAIL_AWS_COGNITO = 'mayank.kumar@ideaqu.com'; //DEV Email
export const EMAIL_AWS_COGNITO = 'cpas@givepls.com';
export const GIVEPLEASE_MICROSITE = 'https://www.givepls.com/';
export const DMS = 'https://web.givepls.com/';
export const CPAS_CAMPAIGN_ID = 41;